import { Setting } from '@120wateraudit/envirio-components/dist/models'
import { ApplicationState } from '../reducers/index'

export const getSettings = (state: ApplicationState): Setting[] =>
  state.settings.items
